import React from "react";
import { Isvg } from "../../../components";
import { NavigatorAction } from "../../../flux";

export default class Reading extends React.Component {
  render() {
    const {
      reading,
      handleDragStart,
      handleDragEnd,
      handleDrop,
      handleDragOver
    } = this.props;
    return (
      <li
        key={reading.uuid}
        ref={reading.uuid}
        draggable="true"
        className={`${this.props.overReadingId === reading.uuid ? "over" : ""}
          ${this.props.movingReadingId === reading.uuid ? "moving" : ""}`}
        onDragStart={() => handleDragStart(reading.uuid)}
        onDragOver={event => handleDragOver(event, reading.uuid)}
        onDragEnd={event => handleDragEnd(event, reading.uuid)}
        onDrop={event => handleDrop(event, reading.uuid)}
      >
        <div className="readingHeader">
          <h4 tabIndex={-1} className="title">
            {reading.description}
          </h4>
          <div className="readingActions">
            <button
              className="button noButton"
              onClick={() =>
                NavigatorAction.push(reading.metadata.tooling, { reading })
              }
            >
              <Isvg src="/img/assignments/assets/img/edit_icon.svg" />
              <span className="offscreen">{i18n.t("base.edit")}</span>
            </button>
            <button
              ref={button => {
                this.deleteButton = button;
              }}
              className="noButton"
              onClick={() =>
                this.props.removeReading(reading.uuid, this.deleteButton)
              }
            >
              <Isvg src="/img/assignments/assets/img/trash_icon.svg" />
              <span className="offscreen">{i18n.t("base.delete")}</span>
            </button>
          </div>
        </div>
      </li>
    );
  }
}
